import React, { useCallback, useMemo } from "react";
import { SearchOption } from "@jsq/ds/core";
import { useGetEntityByArenaLazyQuery } from "../../../graphql/supergraph.index";
import { clientContext } from "../../../utils/graphql_utils";
import { CustomFilter } from "../CustomFilter";
import { EntityFilterProps, EntityEdgeType } from "./types";

/**
 * The custom filtering component for filtering based on the entity name.
 * @param filterProps props fed by the AgGrid filtering model
 */
export const EntityFilter = (filterProps: EntityFilterProps) => {
  const { dependentFilter, ...restFilterProps } = filterProps;
  const [fetchEntityQuery, { data, loading }] = useGetEntityByArenaLazyQuery();

  // Extracting the entity list from the response
  const entityLists: SearchOption[] = useMemo(
    () =>
      data?.investmentEntitiesByArena?.edges.map((entity: EntityEdgeType) => ({
        id: entity.node.id,
        label: entity.node.name,
      })) || [],
    [data],
  );

  // Fetching the entity info based on the dependent(arenaId) and the search term
  const fetchEntityInfo = useCallback(
    async (dependentId: string, searchTerm: string) => {
      await fetchEntityQuery({
        context: clientContext(),
        variables: {
          arenaId: dependentId,
          searchTerm: searchTerm,
        },
        fetchPolicy: "no-cache",
      });
    },
    [fetchEntityQuery],
  );

  return (
    <CustomFilter
      dependentFilter={dependentFilter}
      filterProps={restFilterProps}
      options={entityLists}
      isLoading={loading}
      infoText="Please select the client first"
      hintText="Search for an entity"
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      optionsFetcher={fetchEntityInfo}
    />
  );
};
